import React from 'react'
import "../css/UserDataDeletion.css";
import Header from '../Common/Header';
import Footer from '../Common/Footer';

function UserDataDeletion() {
  return (
    <>
    <Header />
 <div className="deletion-container">
      <div className="deletion-content">
        <h1>User Data Deletion Policy</h1>
        <p className="last-updated">Last updated: July 28, 2025</p>

        <section>
          <h2>1. Overview</h2>
          <p>
            At SessLink, we value your privacy and are committed to giving you control over your personal data. This policy outlines how you can request the deletion of your data from our systems, especially when interacting with us via WhatsApp or other digital platforms.
          </p>
        </section>

        <section>
          <h2>2. What Data Can Be Deleted?</h2>
          <p>You may request deletion of the following data:</p>
          <ul>
            <li>Your phone number and associated contact details</li>
            <li>Chat history and messages exchanged via WhatsApp</li>
            <li>Service-related metadata (like timestamps or session logs)</li>
          </ul>
        </section>

        <section>
          <h2>3. How to Request Data Deletion</h2>
          <p>You can request deletion through any of the following methods:</p>
          <ul>
            <li>Email us at <a href="mailto:support@sesslink.com">support@sesslink.com</a></li>
            <li>Reply to our WhatsApp bot with the keyword: <strong>"DELETE MY DATA"</strong></li>
          </ul>
        </section>

        <section>
          <h2>4. Processing Time</h2>
          <p>
            Once a valid request is received, we will delete your data within <strong>7 business days</strong> and confirm via email or WhatsApp.
          </p>
        </section>

        <section>
          <h2>5. Exceptions</h2>
          <p>
            In certain cases, we may be required by law or legal obligations to retain some information for a specific period, such as billing records or legal compliance documentation.
          </p>
        </section>

        <section>
          <h2>6. Contact</h2>
          <p>
            For any questions regarding this policy, please contact us at <a href="mailto:support@sesslink.com">support@sesslink.com</a>.
          </p>
        </section>
      </div>
    </div>
    <Footer />
    </>
  )
}

export default UserDataDeletion
